<template>
  <div>
    <div style="margin-bottom: 20px; text-align: left">
      <el-button type="primary" @click="createFree">新增</el-button>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall" :isPagination="query" 
    >
      <span
        slot="logisticsCompany"
        slot-scope="{ text, record, index }"
        >{{ logisticsCompanyList[text] }}</span
      >
      <span
        slot="title"
        style="margin-right: auto; font-weight: 600; color: #40a9ff"
        >{{ type }}</span
      >
      <a
        slot="action"
        slot-scope="{ text, record, index }"
        href="javascript:;"
        style="padding: 0 10px"
        @click="edit(record)"
        >编辑</a
      >
    </WmsTable>
    <SetFree
      ref="SetFree"
      :type="type"
      :warehouseList="warehouseList"
      :forwarder="forwarder"
      @submitCallBack="submitCallBack"
    />
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { columns } from "@/views/configure/shipWeightFree/components/indexData";
import SetFree from "@/views/configure/shipWeightFree/components/SetFree";
import { weightCostConfigList } from "@/apis/configure";
export default {
  name: "B2B",
  components: {
    WmsTable,
    SetFree,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    warehouseList: {
      type: Array,
      required: true,
    },
    forwarder: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      logisticsCompanyList:{
        OCS: 'OCS',
        YD: '杭州义达',
        SKB: '杭州思凯比',
        TH: '广州天汇'
      }
    };
  },
  mounted() {
    this.getDataSource();
  },
  methods: {
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    getDataSource: function () {
      let params = {
        systemSource: this.type == "B2B" ? 2 : 1,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
      };
      weightCostConfigList(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
        }
      });
      // this.dataSource = [
      //   {
      //     id: 1,
      //     name: 1,
      //     warehouse: 1,
      //     wareName: 1,
      //     tell: 1,
      //     address: 1,
      //     category: 1,
      //     createTime: 1,
      //   }
      // ]
    },
    submitCallBack() {
      this.getDataSource();
    },
    createFree: function () {
      this.$refs["SetFree"].open({
        warehouse: this.$store.getters.getWareCode,
      });
    },
    edit: function (r) {
      console.log(r);
      this.$refs["SetFree"].open({...r});
      // this.$nextTick(() => {
      //   this.$forceUpdate();
      // });
    },
  },
};
</script>

<style scoped></style>
